<template>
    <div>
        <div class="offcanvas offcanvas-start" style="width:100%;margin-top: 50px;" tabindex="-1" id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel">
            <div class="offcanvas-header" :style="skin.side_bar.header + skin.side_bar.header_text"
                style="display: none;">
                <button id="closeSideBar" type="button" class="btn text-reset" data-bs-dismiss="offcanvas"
                    aria-label="Close">
                    <span style="color:white;font-size:large"><i class="fas fa-times"></i></span>
                </button>
            </div>
            <div class="offcanvas-body p-0" :style="skin.side_bar.body">
                <div class="p-3">
                    <div class="p-2">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('sports') }}</span>
                    </div>
                    <div v-for="item in categories" :key="item.category" @click="change_view(item.category)"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1">
                        <div class="d-flex">
                            <img :src="item.icon" class="me-1">
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text"
                                style="text-transform: capitalize;">{{ translate(item.name1).toLowerCase() }}</span>
                        </div>
                    </div>
                    <div class="p-2">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('games1') }}</span>
                    </div>
                    <div v-for="item in otherCategories" :key="item.category" @click="change_view(item.category)"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1">
                        <div class="d-flex">
                            <i v-if="item.iconClass" :class="item.iconClass" class="me-1" style="width: 20px;"></i>
                            <img v-else :src="item.icon" class="me-1">
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text"
                                style="text-transform: capitalize;">{{ menuLabel(item) }}</span>
                        </div>
                    </div>
                    <div class="p-2">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('others') }}</span>
                    </div>
                    <div style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.header_desktop.selection" class="p-2 mb-1"
                        @click="openSupportModalJivo()">
                        <div class="d-flex">
                            <svg style="width: 20px;" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_10434_32190)">
                                    <path
                                        d="M18.5625 10.3125C17.6579 10.3125 16.9219 11.0485 16.9219 11.9531V18.5156C16.9219 19.4203 17.6579 20.1562 18.5625 20.1562C19.4671 20.1562 20.2031 19.4203 20.2031 18.5156V11.9531C20.2031 11.0485 19.4671 10.3125 18.5625 10.3125Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M10.5938 19.7812C9.67711 19.7812 8.89556 20.3691 8.60531 21.1875H7.875C7.09495 21.1875 6.43364 20.6697 6.21633 19.9599C6.72947 19.6826 7.07812 19.1399 7.07812 18.5156V11.9531C7.07812 11.047 6.34359 10.3125 5.4375 10.3125C4.53141 10.3125 3.79688 11.047 3.79688 11.9531V18.5156C3.79688 19.1905 4.20455 19.77 4.78697 20.0219C5.05547 21.483 6.3375 22.5938 7.875 22.5938H8.60531C8.89556 23.4121 9.67711 24 10.5938 24C11.7569 24 12.7031 23.0537 12.7031 21.8906C12.7031 20.7275 11.7569 19.7812 10.5938 19.7812Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M16.1099 7.7158H16.0985C16.1062 6.3703 16.1096 4.98636 16.0929 4.78555C16.0531 4.30878 15.7645 3.91925 15.3576 3.7932C14.9526 3.66786 14.5243 3.82217 14.2114 4.20608C13.8879 4.60302 12.4079 7.271 11.962 8.07927C11.8418 8.29705 11.8457 8.56217 11.9722 8.77639C12.0986 8.99061 12.3289 9.12205 12.5776 9.12205H14.6826C14.6801 9.45833 14.6776 9.7805 14.6751 10.073C14.6717 10.4614 14.9838 10.7789 15.3721 10.7822H15.3783C15.7637 10.7822 16.0779 10.4714 16.0812 10.0851C16.0832 9.85367 16.086 9.51631 16.089 9.12205H16.1099C16.4982 9.12205 16.813 8.80724 16.813 8.41892C16.813 8.03061 16.4982 7.7158 16.1099 7.7158ZM14.6919 7.7158H13.7729C14.1075 7.11819 14.4327 6.54519 14.6985 6.08624C14.6976 6.55789 14.6952 7.12677 14.6919 7.7158Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M11.736 6.23705C11.7502 6.14353 11.7757 6.01134 11.7815 5.86481C11.7815 4.6987 10.8328 3.75 9.6666 3.75C8.65827 3.75 7.78555 4.46733 7.59144 5.45569C7.51659 5.83673 7.76484 6.2063 8.14588 6.28111C8.52693 6.35597 8.89649 6.10772 8.9713 5.72667C9.03623 5.39616 9.32863 5.15625 9.66655 5.15625C10.0448 5.15625 10.3548 5.45409 10.3742 5.82759L10.3586 5.95022C10.2919 6.20972 10.1299 6.52781 9.88846 6.87277C9.01555 8.11997 8.49468 8.80195 8.21488 9.16838C7.86351 9.62841 7.68716 9.85931 7.80562 10.2443C7.87569 10.4722 8.04805 10.647 8.27844 10.7238C8.37112 10.7547 8.45465 10.7826 9.54149 10.7826C9.96355 10.7826 10.537 10.7783 11.321 10.7685C11.7093 10.7636 12.0201 10.4449 12.0153 10.0566C12.0104 9.67125 11.6966 9.36225 11.3124 9.36225C11.3094 9.36225 11.3063 9.36225 11.3034 9.3623C10.8045 9.36858 10.2774 9.37294 9.82129 9.37444C10.1197 8.97305 10.5187 8.42484 11.0407 7.67911C11.3989 7.16705 11.6329 6.68189 11.736 6.23705Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M23.0156 12.0752V11.0156C23.0156 8.07323 21.8698 5.307 19.7892 3.22645C17.7086 1.14581 14.9424 0 12 0C9.05761 0 6.29138 1.14581 4.21078 3.22641C2.13019 5.30695 0.984375 8.07323 0.984375 11.0156V12.0752C0.419484 12.4541 0.046875 13.0983 0.046875 13.8281V16.6406C0.046875 17.8037 0.993141 18.75 2.15625 18.75H2.39062V11.0156C2.39062 5.71702 6.70139 1.40625 12 1.40625C17.2986 1.40625 21.6094 5.71697 21.6094 11.0156V18.75H21.8438C23.0069 18.75 23.9531 17.8037 23.9531 16.6406V13.8281C23.9531 13.0983 23.5805 12.4541 23.0156 12.0752Z"
                                        fill="#EDEDED"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_10434_32190">
                                        <rect width="24" height="24" fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">{{ translate('soporte') }}</span>
                        </div>
                    </div>
                    <div v-if="user?.user_data?.data?.parentPhone"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1"
                        @click="openWhatsapp">
                        <div class="d-flex align-items-center"
                            style="text-decoration: none;">
                            <i class="fab fa-whatsapp" style="width: 20px;"></i>
                            &nbsp;&nbsp;
                            <span :style="skin.side_bar.navigation_text">
                              {{ translate('whatsapp').replace('whatsapp', 'WhatsApp') }}
                            </span>
                        </div>
                    </div>
                    <div v-if="user.user_data?.data?.parentPhone" role="button"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1"
                        @click="openContactAgent">
                        <div class="d-flex align-items-center">
                            <i class="fa fa-refresh" style="width: 20px;"></i>
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Recargar</span>
                        </div>
                    </div>

                    <div v-if="skin.tonder && canUseTonder" @click="change_view('tonder')"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1">
                        <div class="d-flex">
                            <svg style="width: 1.3rem;height: 1.3rem;" fill="#f5f5f5" viewBox="0 0 60 60" id="Capa_1"
                                version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink" stroke="#f5f5f5">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <g>
                                        <path
                                            d="M36,0h-9c-8.411,0-15,13.178-15,30s6.589,30,15,30h9c8.411,0,15-13.178,15-30S44.411,0,36,0z M30.511,2 c-0.04,0.031-0.079,0.07-0.119,0.101c-0.293,0.23-0.582,0.473-0.865,0.738c-0.02,0.019-0.041,0.035-0.061,0.054 c-0.3,0.283-0.592,0.591-0.879,0.912C28.529,3.87,28.471,3.934,28.414,4h-6.14C23.747,2.717,25.342,2,27,2H30.511z M20.414,54 c-0.467-0.607-0.914-1.277-1.342-2h6.637c0.02,0.036,0.038,0.074,0.058,0.111c0.022,0.04,0.042,0.082,0.064,0.122 c0.241,0.44,0.491,0.859,0.746,1.267c0.057,0.091,0.114,0.179,0.171,0.268c0.05,0.077,0.098,0.157,0.149,0.232H20.414z M16.412,14 h6.835c-0.054,0.176-0.109,0.351-0.162,0.53c-0.03,0.103-0.059,0.208-0.089,0.312c-0.109,0.381-0.215,0.766-0.316,1.158h-6.874 C15.996,15.315,16.198,14.648,16.412,14z M18.007,10h6.727c-0.136,0.308-0.27,0.619-0.4,0.939 c-0.029,0.071-0.056,0.145-0.085,0.217c-0.111,0.279-0.222,0.558-0.328,0.844h-6.786C17.412,11.304,17.703,10.637,18.007,10z M20.414,6h6.484c-0.05,0.076-0.099,0.155-0.149,0.232C26.691,6.321,26.634,6.41,26.577,6.5c-0.255,0.407-0.505,0.827-0.746,1.267 c-0.022,0.04-0.042,0.082-0.064,0.122C25.747,7.926,25.728,7.964,25.709,8h-6.637C19.5,7.277,19.947,6.607,20.414,6z M14,30 c0-0.672,0.016-1.338,0.039-2h6.996C21.014,28.661,21,29.326,21,30s0.014,1.339,0.035,2h-6.996C14.016,31.338,14,30.672,14,30z M21.192,25.117c-0.005,0.062-0.011,0.123-0.016,0.186c-0.017,0.23-0.03,0.465-0.045,0.697h-6.99c0.071-1.017,0.167-2.018,0.29-3 h6.964c-0.009,0.081-0.014,0.164-0.023,0.245C21.303,23.862,21.242,24.485,21.192,25.117z M21.131,34 c0.015,0.232,0.027,0.466,0.045,0.697c0.005,0.063,0.011,0.124,0.016,0.186c0.05,0.632,0.111,1.255,0.179,1.872 c0.009,0.081,0.014,0.165,0.023,0.245h-6.964c-0.122-0.982-0.219-1.983-0.29-3H21.131z M21.661,39 c0.008,0.05,0.016,0.098,0.024,0.148c0.015,0.094,0.031,0.186,0.047,0.28c0.091,0.57,0.192,1.131,0.299,1.685 c0.025,0.13,0.049,0.261,0.075,0.389c0.034,0.167,0.068,0.333,0.103,0.498h-6.907c-0.221-0.971-0.413-1.974-0.58-3H21.661z M22.209,18c-0.035,0.165-0.069,0.331-0.103,0.498c-0.026,0.129-0.05,0.259-0.075,0.389c-0.107,0.554-0.208,1.115-0.299,1.685 c-0.015,0.094-0.032,0.186-0.047,0.28c-0.008,0.049-0.016,0.098-0.024,0.148h-6.94c0.168-1.026,0.36-2.029,0.58-3H22.209z M22.681,44c0.101,0.392,0.207,0.777,0.316,1.158c0.03,0.104,0.058,0.209,0.089,0.312c0.053,0.178,0.107,0.354,0.162,0.53h-6.835 c-0.214-0.648-0.416-1.315-0.605-2H22.681z M23.922,48c0.106,0.287,0.217,0.566,0.328,0.844c0.029,0.072,0.056,0.146,0.085,0.217 c0.13,0.319,0.264,0.631,0.4,0.939h-6.727c-0.305-0.637-0.596-1.304-0.871-2H23.922z M30.511,58H27c-1.658,0-3.253-0.717-4.727-2 h6.14c0.057,0.066,0.115,0.13,0.173,0.195c0.288,0.321,0.58,0.629,0.879,0.912c0.02,0.019,0.041,0.036,0.061,0.054 c0.283,0.264,0.572,0.507,0.865,0.737C30.432,57.93,30.471,57.969,30.511,58z M36,58c-7.047,0-13-12.822-13-28S28.953,2,36,2 s13,12.822,13,28S43.047,58,36,58z">
                                        </path>
                                        <path
                                            d="M36,4c-3.359,0-6.973,4.657-9.108,11.97l-0.096-0.265l-0.723,3.45c-0.101,0.483-0.179,0.981-0.266,1.473 c-0.017,0.097-0.036,0.193-0.052,0.291c-0.095,0.558-0.181,1.121-0.258,1.69c-0.053,0.39-0.103,0.785-0.148,1.184 c-0.04,0.359-0.08,0.717-0.112,1.08c-0.063,0.673-0.113,1.357-0.151,2.05c-0.007,0.128-0.016,0.255-0.022,0.383 C25.022,28.189,25,29.087,25,30c0,0.889,0.022,1.765,0.062,2.626c0.006,0.135,0.015,0.269,0.022,0.404 c0.036,0.666,0.084,1.322,0.142,1.969c0.035,0.399,0.077,0.794,0.121,1.188c0.04,0.35,0.083,0.697,0.129,1.041 c0.083,0.627,0.176,1.246,0.281,1.859c0.01,0.061,0.022,0.121,0.032,0.182c0.084,0.481,0.159,0.969,0.256,1.441l0.701,3.398 l0.094-0.252C28.969,51.271,32.614,56,36,56c5.192,0,11-11.119,11-26S41.192,4,36,4z M28.048,25.062 c0.284,0.785,0.907,1.324,1.626,1.407l2.073,0.239l0.253-0.777c0.67-2.056,1.829-3.228,3.443-3.484l0.679-0.108l0.143-0.673 c0.093-0.438,0.26-0.604,0.255-0.617l0.75,0.231c0.087,0.027,0.385,0.3,0.568,0.942l0.128,0.449l0.426,0.19 c0.564,0.251,1.072,0.599,1.51,1.033c0.188,0.186,0.327,0.338,0.439,0.462c0.39,0.427,0.697,0.695,1.188,0.773 c-0.002,0.005-0.004,0.011-0.006,0.017c-0.534,1.464-0.59,3.156-0.542,4.318c0.007,0.175,0.011,0.354,0.011,0.537 c0,4.036-0.831,6.304-2.614,7.138l-0.414,0.193l-0.125,0.44c-0.183,0.647-0.481,0.922-0.57,0.95l-0.704,0.238 c-0.04-0.021-0.208-0.187-0.3-0.625l-0.143-0.672l-0.679-0.108c-1.615-0.256-2.773-1.429-3.443-3.484l-0.253-0.777l-2.082,0.24 c-0.71,0.082-1.331,0.611-1.617,1.38l-0.632,1.689c-0.025-0.201-0.052-0.399-0.075-0.603c-0.07-0.626-0.127-1.26-0.175-1.898 c-0.026-0.344-0.057-0.682-0.076-1.033C27.036,32.057,27,31.036,27,30c0-1.044,0.037-2.071,0.093-3.089 c0.02-0.348,0.05-0.683,0.075-1.024c0.049-0.656,0.109-1.305,0.181-1.948c0.023-0.204,0.049-0.403,0.075-0.604L28.048,25.062z M36,54c-2.332,0-6.09-4.936-7.922-13.454l1.844-4.933c0.018-0.048,0.038-0.082,0.053-0.103l0.409-0.047 c1.045,2.524,2.699,3.547,4.12,3.932c0.232,0.574,0.592,1.021,1.046,1.288c0.474,0.279,1.028,0.343,1.558,0.18l0.749-0.23 c0.751-0.23,1.392-0.923,1.765-1.888c3.011-1.719,3.371-5.784,3.371-8.745c0-0.211-0.005-0.417-0.013-0.62 c-0.057-1.387,0.093-2.647,0.423-3.549c0.183-0.502,0.317-0.722,0.38-0.808c0.318-0.432,0.276-0.991,0.093-1.354 c-0.191-0.378-0.563-0.613-0.971-0.613c-0.225,0-0.49,0.017-0.786,0.066c-0.065,0.011-0.122,0.021-0.17,0.027 c-0.038-0.041-0.08-0.088-0.129-0.143c-0.13-0.143-0.292-0.319-0.509-0.535c-0.504-0.498-1.073-0.915-1.698-1.242 c-0.375-0.952-1.011-1.634-1.754-1.862l-0.749-0.23c-0.53-0.164-1.084-0.1-1.558,0.18c-0.454,0.267-0.814,0.713-1.046,1.287 c-1.421,0.385-3.075,1.408-4.12,3.932l-0.399-0.046c-0.016-0.022-0.038-0.058-0.056-0.108l-1.823-5.05C29.948,10.89,33.68,6,36,6 c3.173,0,9,9.112,9,24S39.173,54,36,54z">
                                        </path>
                                        <path
                                            d="M9,46.905c-0.552,0-1,0.448-1,1v3.497c-2.987-1.283-6-3.355-6-6.497c0-2.158,1.932-4.291,5.439-6.007 c0.496-0.243,0.702-0.842,0.459-1.338c-0.243-0.496-0.84-0.701-1.338-0.459C1.138,39.754,0,42.81,0,44.905 c0,2.419,1.278,5.717,7.011,8.242L4.4,55.105c-0.442,0.331-0.531,0.958-0.2,1.4c0.196,0.262,0.497,0.4,0.801,0.4 c0.208,0,0.419-0.065,0.599-0.2l4-3c0.019-0.014,0.028-0.036,0.046-0.052c0.053-0.045,0.094-0.097,0.136-0.153 c0.038-0.05,0.076-0.098,0.103-0.153c0.021-0.042,0.036-0.085,0.051-0.13c0.001-0.002,0.003-0.004,0.004-0.006 c0.005-0.013,0.002-0.025,0.006-0.038c0.019-0.067,0.035-0.131,0.04-0.2C9.988,52.95,10,52.929,10,52.905v-5 C10,47.353,9.552,46.905,9,46.905z">
                                        </path>
                                        <path
                                            d="M52.989,5.853L55.6,3.895c0.442-0.331,0.531-0.958,0.2-1.4c-0.331-0.44-0.956-0.532-1.4-0.2l-4,3 c-0.019,0.014-0.028,0.036-0.046,0.052c-0.053,0.045-0.094,0.097-0.136,0.153c-0.038,0.05-0.076,0.098-0.103,0.153 c-0.021,0.042-0.036,0.085-0.051,0.131c-0.001,0.002-0.003,0.003-0.003,0.006c-0.005,0.013-0.002,0.026-0.006,0.038 c-0.019,0.067-0.035,0.131-0.04,0.2C50.012,6.05,50,6.071,50,6.095v5c0,0.552,0.448,1,1,1s1-0.448,1-1V7.598 c2.987,1.283,6,3.355,6,6.497c0,2.158-1.932,4.291-5.439,6.007c-0.496,0.243-0.702,0.842-0.459,1.338 C52.275,21.794,52.631,22,53.001,22c0.147,0,0.297-0.033,0.438-0.102C58.862,19.246,60,16.19,60,14.095 C60,11.676,58.722,8.377,52.989,5.853z">
                                        </path>
                                    </g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </g>
                            </svg>

                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text"
                                style="text-transform: capitalize;"> Recargas/Descargas</span>
                        </div>
                    </div>

                    <div v-if="skin.espiral_app" @click="change_view('espiral_app')"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1">
                        <div class="d-flex">
                            <svg style="width: 1.3rem;height: 1.3rem;" fill="#f5f5f5" viewBox="0 0 512 512"
                                xmlns="http://www.w3.org/2000/svg" stroke="#f5f5f5">
                                <path d="M448 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V128C512 92.65 483.35 64 448 64zM64 96h384c17.67 0 32 14.33 32 32v32H32V128C32 110.33 46.33 96 64 96zM448 416H64c-17.67 0-32-14.33-32-32V192h448v192C480 401.67 465.67 416 448 416zM160 288c0 17.67-14.33 32-32 32s-32-14.33-32-32 14.33-32 32-32S160 270.33 160 288z"/>
                            </svg>
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text"
                                style="text-transform: capitalize;"> Recargas</span>
                        </div>
                    </div>
                    <div v-if="!skin.lobby">
                        <languageSelector :skin="skin" :language="language" :movil="movil">
                        </languageSelector>
                    </div>
                    <div v-if="skin.redes" class="p-2">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('social') }}</span>
                    </div>
                    <template v-if="skin.redes">
                        <div v-for="(red, key) in skin.redes" :key="key" v-if="red.enabled"
                            style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                            :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1"
                            @click="openSocial(red.url)">
                            <div class="d-flex align-items-center">
                                <svg v-if="key === 'x'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" :style="red.btn_style" style="width: 20px;"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
                                <i v-else :class="'fab fa-' + socialIcon(key)" :style="red.btn_style" style="width: 20px;"></i>
                                &nbsp;&nbsp;
                                <span :style="skin.side_bar.navigation_text" style="text-transform: capitalize;">{{ key }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        </div>
    </div>
</template>

<script>
import languageSelector from '../../header/language.vue';
import historialIngresos from "../../header/historialIngresos.vue";
import { getGamanzaMenuCategories } from '@/utils/gamanzaMenuCategories';

export default {
    name: 'Sidebar',
    components: {
        languageSelector,
        historialIngresos
    },
    props: ['translation', 'language'],
    data() {
        return {
            movil: 'mobile',
            booking_code: '',
        }
    },
    computed: {
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        favoritos() {
            return this.$store.getters['live/getFavorites'];
        },
        sports() {
            return this.$store.getters['live/getSports'];
        },
        skin() {
            return this.$store.getters['getCurrentSkin'];
        },
        categories() {
            return this.skin?.categories?.filter(category =>
                category.active && ["sport", "sportlive"].includes(category.category)
            ) || [];
        },
        otherCategories() {
            const categories = this.skin?.categories?.filter(category =>
                category.active && !["sport", "sportlive", "lobby", "tonder", "espiral_app"].includes(category.category)
            ) || [];

            return [...categories, ...this.gamanzaMenuCategories];
        },
        gamanzaMenuCategories() {
            return getGamanzaMenuCategories(this.skin, this.user, this.gamanzaReady, this.language);
        },
        gamanzaReady() {
            return this.$store.getters['getGamanzaReady'];
        },
        user() {
            return this.$store.getters['getUserData'];
        },
        canUseTonder() {
            return Number(this.user?.user_data?.data?.edit_tickets) === 0;
        },
        prematchTarget() {
            return this.$store.getters['getPrematchTarget'];
        },
        time2() {
            return this.$store.getters['prematch_2/getTime'];
        },
        timeLoading() {
            return this.$store.getters['prematch_2/getTimeLoading'];
        },
        sports_prematch() {
            return this.$store.getters['prematch_2/getSports'];
        },
        nav_activeCss() {
            return {
                '--bar': this.skin.side_bar.nav_active_bar,
                '--text': this.skin.side_bar.nav_active_text,
            }
        },
        config() {
            return this.$store.getters['getConfig'];
        },
    },
    methods: {
        menuLabel(item) {
            return item.iconClass ? item.name : this.translate(item.name).toLowerCase();
        },
        openSupportModalJivo() {
            const sidebarEl = document.getElementById('offcanvasExample');
            const instance = bootstrap.Offcanvas.getInstance(sidebarEl);
            instance.hide();
            const jivoMobileElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'none'; // Ocultar el elemento móvil
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'block'; // Mostrar el elemento móvil
                    jivo_api.open()
                }
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        active: function (id) {
            let items = document.getElementsByClassName("item-menu");
            [...items].forEach(item => {
                item.classList.remove('nav_active1');
                item.classList.remove('active');
            });
            document.getElementById(id).classList.add('nav_active1');
            document.getElementById(id).classList.add('active');
        },
        check_booking() {
            if (this.booking_code != '') {
                this.$store.dispatch('getBooking', this.booking_code);
            }
            else {
                this.alert.message = this.translate('Ingresa un código de reserva válido');
                this.alert.type = 'danger';
                this.alert.active = true;
                setTimeout(this.alert_off, 5000);
            }
        },
        change_view(view) {
            document.getElementById('closeSideBar').click();
            this.$store.dispatch("changeView", view);
        },
        closeSideBar() {
            document.getElementById('closeSideBar').click();
        },
        openWhatsapp() {
            const phone = this.user?.user_data?.data?.parentPhone;
            if (phone) window.open(`https://api.whatsapp.com/send?phone=${phone}`, "_blank", "noopener");
            this.closeSideBar();
        },
        openContactAgent() {
            this.closeSideBar();
            this.$root.$emit('openContactAgent');
        },
        openSocial(url) {
            window.open(url, '_blank', 'noopener');
        },
        socialIcon(key) {
            const icons = {
                facebook: 'facebook',
                instagram: 'instagram',
                x: 'x-twitter',
                youtube: 'youtube',
                tiktok: 'tiktok',
            };
            return icons[key] || key;
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-group2 {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.nav_active1 {
    color: var(--text);
    border-bottom: var(--bar);
}
</style>
